export const countries = [
  {
    label: 'USA',
    name: 'United States',
    countryCode: '+1',
    iso: 'US',
    flag: 'assets/svg-flags/us.svg',
    mask: '(000) 000-0000'
  },
  {
    label: 'Others',
    name: 'Afghanistan',
    countryCode: '+93',
    iso: 'AF',
    flag: 'assets/svg-flags/af.svg',
    mask: '00-000-0000'
  },
  {
    label: 'Others',
    name: 'Aland Islands',
    countryCode: '+358',
    iso: 'AX',
    flag: 'assets/svg-flags/ax.svg',
    mask: '(000) 000-00-00'
  },
  {
    label: 'Others',
    name: 'Albania',
    countryCode: '+355',
    iso: 'AL',
    flag: 'assets/svg-flags/al.svg',
    mask: '(000) 000-000'
  },
  {
    label: 'Others',
    name: 'Algeria',
    countryCode: '+213',
    iso: 'DZ',
    flag: 'assets/svg-flags/dz.svg',
    mask: '00-000-0000'
  },
  {
    label: 'Others',
    name: 'American Samoa',
    countryCode: '+1',
    iso: 'AS',
    flag: 'assets/svg-flags/as.svg',
    mask: '(684) 000-0000'
  },
  {
    label: 'Others',
    name: 'Andorra',
    countryCode: '+376',
    iso: 'AD',
    flag: 'assets/svg-flags/ad.svg',
    mask: '000-000'
  },
  {
    label: 'Others',
    name: 'Angola',
    countryCode: '+244',
    iso: 'AO',
    flag: 'assets/svg-flags/ao.svg',
    mask: '(000) 000-000'
  },
  {
    label: 'Others',
    name: 'Anguilla',
    countryCode: '+1',
    iso: 'AI',
    flag: 'assets/svg-flags/ai.svg',
    mask: '(264) 000-0000'
  },
  {
    label: 'Others',
    name: 'Antarctica',
    countryCode: '+672',
    iso: 'AQ',
    flag: 'assets/svg-flags/aq.svg',
    mask: '100-000'
  },
  {
    label: 'Others',
    name: 'Antigua and Barbuda',
    countryCode: '+1',
    iso: 'AG',
    flag: 'assets/svg-flags/ag.svg',
    mask: '(268) 000-0000'
  },
  {
    label: 'Others',
    name: 'Argentina',
    countryCode: '+54',
    iso: 'AR',
    flag: 'assets/svg-flags/ar.svg',
    mask: '(000) 000-0000'
  },
  {
    label: 'Others',
    name: 'Armenia',
    countryCode: '+374',
    iso: 'AM',
    flag: 'assets/svg-flags/am.svg',
    mask: '00-000-000'
  },
  {
    label: 'Others',
    name: 'Aruba',
    countryCode: '+297',
    iso: 'AW',
    flag: 'assets/svg-flags/aw.svg',
    mask: '000-0000'
  },
  {
    label: 'Others',
    name: 'Ascension Island',
    countryCode: '+247',
    iso: 'AC',
    flag: 'assets/svg-flags/sh.svg',
    mask: '0000'
  },
  {
    label: 'Others',
    name: 'Australia',
    countryCode: '+61',
    iso: 'AU',
    flag: 'assets/svg-flags/au.svg',
    mask: '0-0000-0000'
  },
  {
    label: 'Others',
    name: 'Austria',
    countryCode: '+43',
    iso: 'AT',
    flag: 'assets/svg-flags/at.svg',
    mask: '(000) 000-0000'
  },
  {
    label: 'Others',
    name: 'Azerbaijan',
    countryCode: '+994',
    iso: 'AZ',
    flag: 'assets/svg-flags/az.svg',
    mask: '00-000-00-00'
  },
  {
    label: 'Others',
    name: 'Bahamas',
    countryCode: '+1',
    iso: 'BS',
    flag: 'assets/svg-flags/bs.svg',
    mask: '(242) 000-0000'
  },
  {
    label: 'Others',
    name: 'Bahrain',
    countryCode: '+973',
    iso: 'BH',
    flag: 'assets/svg-flags/bh.svg',
    mask: '0000-0000'
  },
  {
    label: 'Others',
    name: 'Bangladesh',
    countryCode: '+880',
    iso: 'BD',
    flag: 'assets/svg-flags/bd.svg',
    mask: '1000-000000'
  },
  {
    label: 'Others',
    name: 'Barbados',
    countryCode: '+1',
    iso: 'BB',
    flag: 'assets/svg-flags/bb.svg',
    mask: '(246) 000-0000'
  },
  {
    label: 'Others',
    name: 'Belarus',
    countryCode: '+375',
    iso: 'BY',
    flag: 'assets/svg-flags/by.svg',
    mask: '(00) 000-00-00'
  },
  {
    label: 'Others',
    name: 'Belgium',
    countryCode: '+32',
    iso: 'BE',
    flag: 'assets/svg-flags/be.svg',
    mask: '(000) 000-000'
  },
  {
    label: 'Others',
    name: 'Belize',
    countryCode: '+501',
    iso: 'BZ',
    flag: 'assets/svg-flags/bz.svg',
    mask: '000-0000'
  },
  {
    label: 'Others',
    name: 'Benin',
    countryCode: '+229',
    iso: 'BJ',
    flag: 'assets/svg-flags/bj.svg',
    mask: '00-00-0000'
  },
  {
    label: 'Others',
    name: 'Bermuda',
    countryCode: '+1',
    iso: 'BM',
    flag: 'assets/svg-flags/bm.svg',
    mask: '(441) 000-0000'
  },
  {
    label: 'Others',
    name: 'Bhutan',
    countryCode: '+975',
    iso: 'BT',
    flag: 'assets/svg-flags/bt.svg',
    mask: [
      '17-000-000',
      '77-000-000',
      '0-000-000'
    ]
  },
  {
    label: 'Others',
    name: 'Bolivia',
    countryCode: '+591',
    iso: 'BO',
    flag: 'assets/svg-flags/bo.svg',
    mask: '0-000-0000'
  },
  {
    label: 'Others',
    name: 'Bosnia and Herzegovina',
    countryCode: '+387',
    iso: 'BA',
    flag: 'assets/svg-flags/ba.svg',
    mask: [
      '00-0000',
      '00-00000'
    ]
  },
  {
    label: 'Others',
    name: 'Botswana',
    countryCode: '+267',
    iso: 'BW',
    flag: 'assets/svg-flags/bw.svg',
    mask: '00-000-000'
  },
  {
    label: 'Others',
    name: 'Brazil',
    countryCode: '+55',
    iso: 'BR',
    flag: 'assets/svg-flags/br.svg',
    mask: [
      '(00) 0000-0000',
      '(00) 00000-0000'
    ]
  },
  {
    label: 'Others',
    name: 'British Indian Ocean Territory',
    countryCode: '+246',
    iso: 'IO',
    flag: 'assets/svg-flags/io.svg',
    mask: '000-0000'
  },
  {
    label: 'Others',
    name: 'Brunei Darussalam',
    countryCode: '+673',
    iso: 'BN',
    flag: 'assets/svg-flags/bn.svg',
    mask: '000-0000'
  },
  {
    label: 'Others',
    name: 'Bulgaria',
    countryCode: '+359',
    iso: 'BG',
    flag: 'assets/svg-flags/bg.svg',
    mask: '(000) 000-000'
  },
  {
    label: 'Others',
    name: 'Burkina Faso',
    countryCode: '+226',
    iso: 'BF',
    flag: 'assets/svg-flags/bf.svg',
    mask: '00-00-0000'
  },
  {
    label: 'Others',
    name: 'Burundi',
    countryCode: '+257',
    iso: 'BI',
    flag: 'assets/svg-flags/bi.svg',
    mask: '00-00-0000'
  },
  {
    label: 'Others',
    name: 'Cambodia',
    countryCode: '+855',
    iso: 'KH',
    flag: 'assets/svg-flags/kh.svg',
    mask: '00-000-000'
  },
  {
    label: 'Others',
    name: 'Cameroon',
    countryCode: '+237',
    iso: 'CM',
    flag: 'assets/svg-flags/cm.svg',
    mask: '0000-0000'
  },
  {
    label: 'Others',
    name: 'Canada',
    countryCode: '+1',
    iso: 'CA',
    flag: 'assets/svg-flags/ca.svg',
    mask: '(000) 000-0000'
  },
  {
    label: 'Others',
    name: 'Cape Verde',
    countryCode: '+238',
    iso: 'CV',
    flag: 'assets/svg-flags/cv.svg',
    mask: '(000) 00-00'
  },
  {
    label: 'Others',
    name: 'Cayman Islands',
    countryCode: '+1',
    iso: 'KY',
    flag: 'assets/svg-flags/ky.svg',
    mask: '(345) 000-0000'
  },
  {
    label: 'Others',
    name: 'Central African Republic',
    countryCode: '+236',
    iso: 'CF',
    flag: 'assets/svg-flags/cf.svg',
    mask: '00-00-0000'
  },
  {
    label: 'Others',
    name: 'Chad',
    countryCode: '+235',
    iso: 'TD',
    flag: 'assets/svg-flags/td.svg',
    mask: '00-00-00-00'
  },
  {
    label: 'Others',
    name: 'Chile',
    countryCode: '+56',
    iso: 'CL',
    flag: 'assets/svg-flags/cl.svg',
    mask: '0-0000-0000'
  },
  {
    label: 'Others',
    name: 'China',
    countryCode: '+86',
    iso: 'CN',
    flag: 'assets/svg-flags/cn.svg',
    mask: [
      '(000) 0000-000',
      '(000) 0000-0000',
      '00-00000-00000'
    ]
  },
  {
    label: 'Others',
    name: 'Christmas Island',
    countryCode: '+61',
    iso: 'CX',
    flag: 'assets/svg-flags/cx.svg',
    mask: '0-0000-0000'
  },
  {
    label: 'Others',
    name: 'Cocos (Keeling)  Islands',
    countryCode: '+61',
    iso: 'CC',
    flag: 'assets/svg-flags/cc.svg',
    mask: '0-0000-0000'
  },
  {
    label: 'Others',
    name: 'Colombia',
    countryCode: '+57',
    iso: 'CO',
    flag: 'assets/svg-flags/co.svg',
    mask: '(000) 000-0000'
  },
  {
    label: 'Others',
    name: 'Comoros',
    countryCode: '+269',
    iso: 'KM',
    flag: 'assets/svg-flags/km.svg',
    mask: '00-00000'
  },
  {
    label: 'Others',
    name: 'Congo',
    countryCode: '+242',
    iso: 'CG',
    flag: 'assets/svg-flags/cg.svg',
    mask: '00-00000'
  },
  {
    label: 'Others',
    name: 'Cook Islands',
    countryCode: '+682',
    iso: 'CK',
    flag: 'assets/svg-flags/ck.svg',
    mask: '00-000'
  },
  {
    label: 'Others',
    name: 'Costa Rica',
    countryCode: '+506',
    iso: 'CR',
    flag: 'assets/svg-flags/cr.svg',
    mask: '0000-0000'
  },
  {
    label: 'Others',
    name: 'Croatia',
    countryCode: '+385',
    iso: 'HR',
    flag: 'assets/svg-flags/hr.svg',
    mask: '00-000-000'
  },
  {
    label: 'Others',
    name: 'Cuba',
    countryCode: '+53',
    iso: 'CU',
    flag: 'assets/svg-flags/cu.svg',
    mask: '0-000-0000'
  },
  {
    label: 'Others',
    name: 'Cyprus',
    countryCode: '+357',
    iso: 'CY',
    flag: 'assets/svg-flags/cy.svg',
    mask: '00-000-000'
  },
  {
    label: 'Others',
    name: 'Czech Republic',
    countryCode: '+420',
    iso: 'CZ',
    flag: 'assets/svg-flags/cz.svg',
    mask: '(000) 000-000'
  },
  {
    label: 'Others',
    name: 'Democratic Republic of the Congo',
    countryCode: '+243',
    iso: 'CD',
    flag: 'assets/svg-flags/cd.svg',
    mask: '(000) 000-000'
  },
  {
    label: 'Others',
    name: 'Denmark',
    countryCode: '+45',
    iso: 'DK',
    flag: 'assets/svg-flags/dk.svg',
    mask: '00-00-00-00'
  },
  {
    label: 'Others',
    name: 'Djibouti',
    countryCode: '+253',
    iso: 'DJ',
    flag: 'assets/svg-flags/dj.svg',
    mask: '00-00-00-00'
  },
  {
    label: 'Others',
    name: 'Dominica',
    countryCode: '+1',
    iso: 'DM',
    flag: 'assets/svg-flags/dm.svg',
    mask: '(767) 000-0000'
  },
  {
    label: 'Others',
    name: 'Dominican Republic',
    countryCode: '+1',
    iso: 'DO',
    flag: 'assets/svg-flags/do.svg',
    mask: [
      '(809) 000-0000',
      '(829) 000-0000',
      '(849) 000-0000'
    ]
  },
  {
    label: 'Others',
    name: 'Ecuador',
    countryCode: '+593',
    iso: 'EC',
    flag: 'assets/svg-flags/ec.svg',
    mask: [
      '0-000-0000',
      '00-000-0000'
    ]
  },
  {
    label: 'Others',
    name: 'Egypt',
    countryCode: '+20',
    iso: 'EG',
    flag: 'assets/svg-flags/eg.svg',
    mask: '(000) 000-0000'
  },
  {
    label: 'Others',
    name: 'El Salvador',
    countryCode: '+503',
    iso: 'SV',
    flag: 'assets/svg-flags/sv.svg',
    mask: '00-00-0000'
  },
  {
    label: 'Others',
    name: 'Equatorial Guinea',
    countryCode: '+240',
    iso: 'GQ',
    flag: 'assets/svg-flags/gq.svg',
    mask: '00-000-0000'
  },
  {
    label: 'Others',
    name: 'Eritrea',
    countryCode: '+291',
    iso: 'ER',
    flag: 'assets/svg-flags/er.svg',
    mask: '0-000-000'
  },
  {
    label: 'Others',
    name: 'Estonia',
    countryCode: '+372',
    iso: 'EE',
    flag: 'assets/svg-flags/ee.svg',
    mask: [
      '000-0000',
      '0000-0000'
    ]
  },
  {
    label: 'Others',
    name: 'Eswatini',
    countryCode: '+268',
    iso: 'SZ',
    flag: 'assets/svg-flags/sz.svg',
    mask: '00-00-0000'
  },
  {
    label: 'Others',
    name: 'Ethiopia',
    countryCode: '+251',
    iso: 'ET',
    flag: 'assets/svg-flags/et.svg',
    mask: '00-000-0000'
  },
  {
    label: 'Others',
    name: 'Falkland Islands (Malvinas) ',
    countryCode: '+500',
    iso: 'FK',
    flag: 'assets/svg-flags/fk.svg',
    mask: '00000'
  },
  {
    label: 'Others',
    name: 'Faroe Islands',
    countryCode: '+298',
    iso: 'FO',
    flag: 'assets/svg-flags/fo.svg',
    mask: '000-000'
  },
  {
    label: 'Others',
    name: 'Fiji',
    countryCode: '+679',
    iso: 'FJ',
    flag: 'assets/svg-flags/fj.svg',
    mask: '00-00000'
  },
  {
    label: 'Others',
    name: 'Finland',
    countryCode: '+358',
    iso: 'FI',
    flag: 'assets/svg-flags/fi.svg',
    mask: '(000) 000-00-00'
  },
  {
    label: 'Others',
    name: 'France',
    countryCode: '+33',
    iso: 'FR',
    flag: 'assets/svg-flags/fr.svg',
    mask: '(000) 000-000'
  },
  {
    label: 'Others',
    name: 'French Guiana',
    countryCode: '+594',
    iso: 'GF',
    flag: 'assets/svg-flags/gf.svg',
    mask: '00000-0000'
  },
  {
    label: 'Others',
    name: 'French Polynesia',
    countryCode: '+689',
    iso: 'PF',
    flag: 'assets/svg-flags/pf.svg',
    mask: '00-00-00'
  },
  {
    label: 'Others',
    name: 'Gabon',
    countryCode: '+241',
    iso: 'GA',
    flag: 'assets/svg-flags/ga.svg',
    mask: '0-00-00-00'
  },
  {
    label: 'Others',
    name: 'Gambia',
    countryCode: '+220',
    iso: 'GM',
    flag: 'assets/svg-flags/gm.svg',
    mask: '(000) 00-00'
  },
  {
    label: 'Others',
    name: 'Georgia',
    countryCode: '+995',
    iso: 'GE',
    flag: 'assets/svg-flags/ge.svg',
    mask: '(000) 000-000'
  },
  {
    label: 'Others',
    name: 'Germany',
    countryCode: '+49',
    iso: 'DE',
    flag: 'assets/svg-flags/de.svg',
    mask: [
      '000-000',
      '(000) 00-00',
      '(000) 00-000',
      '(000) 00-0000',
      '(000) 000-0000',
      '(0000) 000-0000'
    ]
  },
  {
    label: 'Others',
    name: 'Ghana',
    countryCode: '+233',
    iso: 'GH',
    flag: 'assets/svg-flags/gh.svg',
    mask: '(000) 000-000'
  },
  {
    label: 'Others',
    name: 'Gibraltar',
    countryCode: '+350',
    iso: 'GI',
    flag: 'assets/svg-flags/gi.svg',
    mask: '000-00000'
  },
  {
    label: 'Others',
    name: 'Greece',
    countryCode: '+30',
    iso: 'GR',
    flag: 'assets/svg-flags/gr.svg',
    mask: '(000) 000-0000'
  },
  {
    label: 'Others',
    name: 'Greenland',
    countryCode: '+299',
    iso: 'GL',
    flag: 'assets/svg-flags/gl.svg',
    mask: '00-00-00'
  },
  {
    label: 'Others',
    name: 'Grenada',
    countryCode: '+1',
    iso: 'GD',
    flag: 'assets/svg-flags/gd.svg',
    mask: '(473) 000-0000'
  },
  {
    label: 'Others',
    name: 'Guadeloupe',
    countryCode: '+590',
    iso: 'GP',
    flag: 'assets/svg-flags/gp.svg',
    mask: '(000) 000-000'
  },
  {
    label: 'Others',
    name: 'Guam',
    countryCode: '+1',
    iso: 'GU',
    flag: 'assets/svg-flags/gu.svg',
    mask: '(671) 000-0000'
  },
  {
    label: 'Others',
    name: 'Guatemala',
    countryCode: '+502',
    iso: 'GT',
    flag: 'assets/svg-flags/gt.svg',
    mask: '0-000-0000'
  },
  {
    label: 'Others',
    name: 'Guernsey',
    countryCode: '+44',
    iso: 'GG',
    flag: 'assets/svg-flags/gg.svg',
    mask: '(0000) 000000'
  },
  {
    label: 'Others',
    name: 'Guinea',
    countryCode: '+224',
    iso: 'GN',
    flag: 'assets/svg-flags/gn.svg',
    mask: '00-000-000'
  },
  {
    label: 'Others',
    name: 'Guinea-Bissau',
    countryCode: '+245',
    iso: 'GW',
    flag: 'assets/svg-flags/gw.svg',
    mask: '0-000000'
  },
  {
    label: 'Others',
    name: 'Guyana',
    countryCode: '+592',
    iso: 'GY',
    flag: 'assets/svg-flags/gy.svg',
    mask: '000-0000'
  },
  {
    label: 'Others',
    name: 'Haiti',
    countryCode: '+509',
    iso: 'HT',
    flag: 'assets/svg-flags/ht.svg',
    mask: '00-00-0000'
  },
  {
    label: 'Others',
    name: 'Holy See (Vatican City State) ',
    countryCode: '+39',
    iso: 'VA',
    flag: 'assets/svg-flags/va.svg',
    mask: '06 69800000'
  },
  {
    label: 'Others',
    name: 'Honduras',
    countryCode: '+504',
    iso: 'HN',
    flag: 'assets/svg-flags/hn.svg',
    mask: '0000-0000'
  },
  {
    label: 'Others',
    name: 'Hong Kong',
    countryCode: '+852',
    iso: 'HK',
    flag: 'assets/svg-flags/hk.svg',
    mask: '0000-0000'
  },
  {
    label: 'Others',
    name: 'Hungary',
    countryCode: '+36',
    iso: 'HU',
    flag: 'assets/svg-flags/hu.svg',
    mask: '(000) 000-000'
  },
  {
    label: 'Others',
    name: 'Iceland',
    countryCode: '+354',
    iso: 'IS',
    flag: 'assets/svg-flags/is.svg',
    mask: '000-0000'
  },
  {
    label: 'Others',
    name: 'India',
    countryCode: '+91',
    iso: 'IN',
    flag: 'assets/svg-flags/in.svg',
    mask: '(0000) 000-000'
  },
  {
    label: 'Others',
    name: 'Indonesia',
    countryCode: '+62',
    iso: 'ID',
    flag: 'assets/svg-flags/id.svg',
    mask: [
      '00-000-00',
      '00-000-000',
      '00-000-0000',
      '(800) 000-000',
      '(800) 000-00-000'
    ]
  },
  {
    label: 'Others',
    name: 'Iran',
    countryCode: '+98',
    iso: 'IR',
    flag: 'assets/svg-flags/ir.svg',
    mask: '(000) 000-0000'
  },
  {
    label: 'Others',
    name: 'Iraq',
    countryCode: '+924',
    iso: 'IQ',
    flag: 'assets/svg-flags/iq.svg',
    mask: '(000) 000-0000'
  },
  {
    label: 'Others',
    name: 'Ireland',
    countryCode: '+353',
    iso: 'IE',
    flag: 'assets/svg-flags/ie.svg',
    mask: '(000) 000-000'
  },
  {
    label: 'Others',
    name: 'Isle of Man',
    countryCode: '+44',
    iso: 'IM',
    flag: 'assets/svg-flags/im.svg',
    mask: '(0000) 000000'
  },
  {
    label: 'Others',
    name: 'Israel',
    countryCode: '+972',
    iso: 'IL',
    flag: 'assets/svg-flags/il.svg',
    mask: [
      '0-000-0000',
      '50-000-0000'
    ]
  },
  {
    label: 'Others',
    name: 'Italy',
    countryCode: '+39',
    iso: 'IT',
    flag: 'assets/svg-flags/it.svg',
    mask: '(000) 0000-000'
  },
  {
    label: 'Others',
    name: 'Ivory Coast / Cote d\'Ivoire',
    countryCode: '+225',
    iso: 'CI',
    flag: 'assets/svg-flags/ci.svg',
    mask: '00-000-000'
  },
  {
    label: 'Others',
    name: 'Jamaica',
    countryCode: '+1',
    iso: 'JM',
    flag: 'assets/svg-flags/jm.svg',
    mask: '(876) 000-0000'
  },
  {
    label: 'Others',
    name: 'Japan',
    countryCode: '+81',
    iso: 'JP',
    flag: 'assets/svg-flags/jp.svg',
    mask: [
      '(000) 000-000',
      '00-0000-0000'
    ]
  },
  {
    label: 'Others',
    name: 'Jersey',
    countryCode: '+44',
    iso: 'JE',
    flag: 'assets/svg-flags/je.svg',
    mask: '(0000) 0000-000000'
  },
  {
    label: 'Others',
    name: 'Jordan',
    countryCode: '+962',
    iso: 'JO',
    flag: 'assets/svg-flags/jo.svg',
    mask: '0-0000-0000'
  },
  {
    label: 'Others',
    name: 'Kazakhstan',
    countryCode: '+77',
    iso: 'KZ',
    flag: 'assets/svg-flags/kz.svg',
    mask: [
      '(600) 000-00-00',
      '(700) 000-00-00'
    ]
  },
  {
    label: 'Others',
    name: 'Kenya',
    countryCode: '+254',
    iso: 'KE',
    flag: 'assets/svg-flags/ke.svg',
    mask: '000-000000'
  },
  {
    label: 'Others',
    name: 'Kiribati',
    countryCode: '+686',
    iso: 'KI',
    flag: 'assets/svg-flags/ki.svg',
    mask: '00-000'
  },
  {
    label: 'Others',
    name: 'Korea, Democratic People\'s Republic of Korea',
    countryCode: '+850',
    iso: 'KP',
    flag: 'assets/svg-flags/kp.svg',
    mask: [
      '000-000',
      '0000-0000',
      '00-000-000',
      '000-0000-000',
      '191-000-0000',
      '0000-0000000000000'
    ]
  },
  {
    label: 'Others',
    name: 'Korea, Republic of South Korea',
    countryCode: '+82',
    iso: 'KR',
    flag: 'assets/svg-flags/kr.svg',
    mask: '00-000-0000'
  },
  {
    label: 'Others',
    name: 'Kosovo',
    countryCode: '+383',
    iso: 'XK',
    flag: 'assets/svg-flags/xk.svg',
    mask: [
      '00-000-000',
      '000-000-000'
    ]
  },
  {
    label: 'Others',
    name: 'Kuwait',
    countryCode: '+965',
    iso: 'KW',
    flag: 'assets/svg-flags/kw.svg',
    mask: '0000-0000'
  },
  {
    label: 'Others',
    name: 'Kyrgyzstan',
    countryCode: '+996',
    iso: 'KG',
    flag: 'assets/svg-flags/kg.svg',
    mask: '(000) 000-000'
  },
  {
    label: 'Others',
    name: 'Laos',
    countryCode: '+856',
    iso: 'LA',
    flag: 'assets/svg-flags/la.svg',
    mask: [
      '00-000-000',
      '(2000) 000-000'
    ]
  },
  {
    label: 'Others',
    name: 'Latvia',
    countryCode: '+371',
    iso: 'LV',
    flag: 'assets/svg-flags/lv.svg',
    mask: '00-000-000'
  },
  {
    label: 'Others',
    name: 'Lebanon',
    countryCode: '+961',
    iso: 'LB',
    flag: 'assets/svg-flags/lb.svg',
    mask: [
      '0-000-000',
      '00-000-000'
    ]
  },
  {
    label: 'Others',
    name: 'Lesotho',
    countryCode: '+266',
    iso: 'LS',
    flag: 'assets/svg-flags/ls.svg',
    mask: '0-000-0000'
  },
  {
    label: 'Others',
    name: 'Liberia',
    countryCode: '+231',
    iso: 'LR',
    flag: 'assets/svg-flags/lr.svg',
    mask: '00-000-000'
  },
  {
    label: 'Others',
    name: 'Libya',
    countryCode: '+218',
    iso: 'LY',
    flag: 'assets/svg-flags/ly.svg',
    mask: [
      '00-000-000',
      '21-000-0000'
    ]
  },
  {
    label: 'Others',
    name: 'Liechtenstein',
    countryCode: '+423',
    iso: 'LI',
    flag: 'assets/svg-flags/li.svg',
    mask: '(000) 000-0000'
  },
  {
    label: 'Others',
    name: 'Lithuania',
    countryCode: '+370',
    iso: 'LT',
    flag: 'assets/svg-flags/lt.svg',
    mask: '(000) 00-000'
  },
  {
    label: 'Others',
    name: 'Luxembourg',
    countryCode: '+352',
    iso: 'LU',
    flag: 'assets/svg-flags/lu.svg',
    mask: '(000) 000-000'
  },
  {
    label: 'Others',
    name: 'Macau',
    countryCode: '+853',
    iso: 'MO',
    flag: 'assets/svg-flags/mo.svg',
    mask: '0000-0000'
  },
  {
    label: 'Others',
    name: 'Madagascar',
    countryCode: '+261',
    iso: 'MG',
    flag: 'assets/svg-flags/mg.svg',
    mask: '00-00-00000'
  },
  {
    label: 'Others',
    name: 'Malawi',
    countryCode: '+265',
    iso: 'MW',
    flag: 'assets/svg-flags/mw.svg',
    mask: [
      '1-000-000',
      '0-0000-0000'
    ]
  },
  {
    label: 'Others',
    name: 'Malaysia',
    countryCode: '+60',
    iso: 'MY',
    flag: 'assets/svg-flags/my.svg',
    mask: [
      '0-000-000',
      '00-000-000',
      '(000) 000-000',
      '00-000-0000'
    ]
  },
  {
    label: 'Others',
    name: 'Maldives',
    countryCode: '+960',
    iso: 'MV',
    flag: 'assets/svg-flags/mv.svg',
    mask: '000-0000'
  },
  {
    label: 'Others',
    name: 'Mali',
    countryCode: '+223',
    iso: 'ML',
    flag: 'assets/svg-flags/ml.svg',
    mask: '00-00-0000'
  },
  {
    label: 'Others',
    name: 'Malta',
    countryCode: '+356',
    iso: 'MT',
    flag: 'assets/svg-flags/mt.svg',
    mask: '0000-0000'
  },
  {
    label: 'Others',
    name: 'Marshall Islands',
    countryCode: '+692',
    iso: 'MH',
    flag: 'assets/svg-flags/mh.svg',
    mask: '000-0000'
  },
  {
    label: 'Others',
    name: 'Martinique',
    countryCode: '+596',
    iso: 'MQ',
    flag: 'assets/svg-flags/mq.svg',
    mask: '(000) 00-00-00'
  },
  {
    label: 'Others',
    name: 'Mauritania',
    countryCode: '+222',
    iso: 'MR',
    flag: 'assets/svg-flags/mr.svg',
    mask: '00-00-0000'
  },
  {
    label: 'Others',
    name: 'Mauritius',
    countryCode: '+230',
    iso: 'MU',
    flag: 'assets/svg-flags/mu.svg',
    mask: '000-0000'
  },
  {
    label: 'Others',
    name: 'Mayotte',
    countryCode: '+262',
    iso: 'YT',
    flag: 'assets/svg-flags/yt.svg',
    mask: '00000-0000'
  },
  {
    label: 'Others',
    name: 'Mexico',
    countryCode: '+52',
    iso: 'MX',
    flag: 'assets/svg-flags/mx.svg',
    mask: [
      '00-00-0000',
      '(000) 000-0000'
    ]
  },
  {
    label: 'Others',
    name: 'Micronesia, Federated States of Micronesia',
    countryCode: '+691',
    iso: 'FM',
    flag: 'assets/svg-flags/fm.svg',
    mask: '000-0000'
  },
  {
    label: 'Others',
    name: 'Moldova',
    countryCode: '+373',
    iso: 'MD',
    flag: 'assets/svg-flags/md.svg',
    mask: '0000-0000'
  },
  {
    label: 'Others',
    name: 'Monaco',
    countryCode: '+377',
    iso: 'MC',
    flag: 'assets/svg-flags/mc.svg',
    mask: [
      '00-000-000',
      '(000) 000-000'
    ]
  },
  {
    label: 'Others',
    name: 'Mongolia',
    countryCode: '+976',
    iso: 'MN',
    flag: 'assets/svg-flags/mn.svg',
    mask: '00-00-0000'
  },
  {
    label: 'Others',
    name: 'Montenegro',
    countryCode: '+382',
    iso: 'ME',
    flag: 'assets/svg-flags/me.svg',
    mask: '00-000-000'
  },
  {
    label: 'Others',
    name: 'Montserrat',
    countryCode: '+1',
    iso: 'MS',
    flag: 'assets/svg-flags/ms.svg',
    mask: '(664) 000-0000'
  },
  {
    label: 'Others',
    name: 'Morocco',
    countryCode: '+212',
    iso: 'MA',
    flag: 'assets/svg-flags/ma.svg',
    mask: '00-0000-000'
  },
  {
    label: 'Others',
    name: 'Mozambique',
    countryCode: '+258',
    iso: 'MZ',
    flag: 'assets/svg-flags/mz.svg',
    mask: '00-000-000'
  },
  {
    label: 'Others',
    name: 'Myanmar',
    countryCode: '+95',
    iso: 'MM',
    flag: 'assets/svg-flags/mm.svg',
    mask: [
      '000-000',
      '0-000-000',
      '00-000-000'
    ]
  },
  {
    label: 'Others',
    name: 'Namibia',
    countryCode: '+224',
    iso: 'NA',
    flag: 'assets/svg-flags/na.svg',
    mask: '00-000-0000'
  },
  {
    label: 'Others',
    name: 'Nauru',
    countryCode: '+674',
    iso: 'NR',
    flag: 'assets/svg-flags/nr.svg',
    mask: '000-0000'
  },
  {
    label: 'Others',
    name: 'Nepal',
    countryCode: '+977',
    iso: 'NP',
    flag: 'assets/svg-flags/np.svg',
    mask: '00-000-000'
  },
  {
    label: 'Others',
    name: 'Netherlands',
    countryCode: '+31',
    iso: 'NL',
    flag: 'assets/svg-flags/nl.svg',
    mask: '00-000-0000'
  },
  {
    label: 'Others',
    name: 'Netherlands Antilles',
    countryCode: '+599',
    iso: 'AN',
    flag: 'assets/svg-flags/an.svg',
    mask: [
      '000-0000',
      '9000-0000'
    ]
  },
  {
    label: 'Others',
    name: 'New Caledonia',
    countryCode: '+687',
    iso: 'NC',
    flag: 'assets/svg-flags/nc.svg',
    mask: '00-0000'
  },
  {
    label: 'Others',
    name: 'New Zealand',
    countryCode: '+24',
    iso: 'NZ',
    flag: 'assets/svg-flags/nz.svg',
    mask: [
      '0-000-000',
      '(000) 000-000',
      '(000) 000-0000'
    ]
  },
  {
    label: 'Others',
    name: 'Nicaragua',
    countryCode: '+505',
    iso: 'NI',
    flag: 'assets/svg-flags/ni.svg',
    mask: '0000-0000'
  },
  {
    label: 'Others',
    name: 'Niger',
    countryCode: '+227',
    iso: 'NE',
    flag: 'assets/svg-flags/ne.svg',
    mask: '00-00-0000'
  },
  {
    label: 'Others',
    name: 'Nigeria',
    countryCode: '+234',
    iso: 'NG',
    flag: 'assets/svg-flags/ng.svg',
    mask: [
      '00-000-00',
      '00-000-000',
      '(000) 000-0000'
    ]
  },
  {
    label: 'Others',
    name: 'Niue',
    countryCode: '+683',
    iso: 'NU',
    flag: 'assets/svg-flags/nu.svg',
    mask: '0000'
  },
  {
    label: 'Others',
    name: 'Norfolk Island',
    countryCode: '+672',
    iso: 'NF',
    flag: 'assets/svg-flags/nf.svg',
    mask: '300-000'
  },
  {
    label: 'Others',
    name: 'North Macedonia',
    countryCode: '+389',
    iso: 'MK',
    flag: 'assets/svg-flags/mk.svg',
    mask: '00-000-000'
  },
  {
    label: 'Others',
    name: 'Northern Mariana Islands',
    countryCode: '+1',
    iso: 'MP',
    flag: 'assets/svg-flags/mp.svg',
    mask: '(670) 000-0000'
  },
  {
    label: 'Others',
    name: 'Norway',
    countryCode: '+47',
    iso: 'NO',
    flag: 'assets/svg-flags/no.svg',
    mask: '(000) 00-000'
  },
  {
    label: 'Others',
    name: 'Oman',
    countryCode: '+968',
    iso: 'OM',
    flag: 'assets/svg-flags/om.svg',
    mask: '00-000-000'
  },
  {
    label: 'Others',
    name: 'Pakistan',
    countryCode: '+92',
    iso: 'PK',
    flag: 'assets/svg-flags/pk.svg',
    mask: '(000) 000-0000'
  },
  {
    label: 'Others',
    name: 'Palau',
    countryCode: '+680',
    iso: 'PW',
    flag: 'assets/svg-flags/pw.svg',
    mask: '000-0000'
  },
  {
    label: 'Others',
    name: 'Palestine',
    countryCode: '+970',
    iso: 'PS',
    flag: 'assets/svg-flags/ps.svg',
    mask: '00-000-0000'
  },
  {
    label: 'Others',
    name: 'Panama',
    countryCode: '+507',
    iso: 'PA',
    flag: 'assets/svg-flags/pa.svg',
    mask: '000-0000'
  },
  {
    label: 'Others',
    name: 'Papua New Guinea',
    countryCode: '+675',
    iso: 'PG',
    flag: 'assets/svg-flags/pg.svg',
    mask: '(000) 00-000'
  },
  {
    label: 'Others',
    name: 'Paraguay',
    countryCode: '+595',
    iso: 'PY',
    flag: 'assets/svg-flags/py.svg',
    mask: '(000) 000-000'
  },
  {
    label: 'Others',
    name: 'Peru',
    countryCode: '+51',
    iso: 'PE',
    flag: 'assets/svg-flags/pe.svg',
    mask: '(000) 000-000'
  },
  {
    label: 'Others',
    name: 'Philippines',
    countryCode: '+63',
    iso: 'PH',
    flag: 'assets/svg-flags/ph.svg',
    mask: '(000) 000-0000'
  },
  {
    label: 'Others',
    name: 'Pitcairn',
    countryCode: '+870',
    iso: 'PN',
    flag: 'assets/svg-flags/pn.svg',
    mask: '000-000-000'
  },
  {
    label: 'Others',
    name: 'Poland',
    countryCode: '+48',
    iso: 'PL',
    flag: 'assets/svg-flags/pl.svg',
    mask: '(000) 000-000'
  },
  {
    label: 'Others',
    name: 'Portugal',
    countryCode: '+351',
    iso: 'PT',
    flag: 'assets/svg-flags/pt.svg',
    mask: '00-000-0000'
  },
  {
    label: 'Others',
    name: 'Puerto Rico',
    countryCode: '+1',
    iso: 'PR',
    flag: 'assets/svg-flags/pr.svg',
    mask: [
      '(787)  000 0000',
      '(939)  000 0000'
    ]
  },
  {
    label: 'Others',
    name: 'Qatar',
    countryCode: '+974',
    iso: 'QA',
    flag: 'assets/svg-flags/qa.svg',
    mask: '0000-0000'
  },
  {
    label: 'Others',
    name: 'Reunion',
    countryCode: '+262',
    iso: 'RE',
    flag: 'assets/svg-flags/re.svg',
    mask: '00000-0000'
  },
  {
    label: 'Others',
    name: 'Romania',
    countryCode: '+40',
    iso: 'RO',
    flag: 'assets/svg-flags/ro.svg',
    mask: '00-000-0000'
  },
  {
    label: 'Others',
    name: 'Russia',
    countryCode: '+7',
    iso: 'RU',
    flag: 'assets/svg-flags/ru.svg',
    mask: '(000) 000-00-00'
  },
  {
    label: 'Others',
    name: 'Rwanda',
    countryCode: '+250',
    iso: 'RW',
    flag: 'assets/svg-flags/rw.svg',
    mask: '(000) 000-000'
  },
  {
    label: 'Others',
    name: 'Saint Barthelemy',
    countryCode: '+590',
    iso: 'BL',
    flag: 'assets/svg-flags/bl.svg',
    mask: '000-00-00-00'
  },
  {
    label: 'Others',
    name: 'Saint Helena, Ascension and Tristan Da Cunha',
    countryCode: '+290',
    iso: 'SH',
    flag: 'assets/svg-flags/sh.svg',
    mask: '0000'
  },
  {
    label: 'Others',
    name: 'Saint Kitts and Nevis',
    countryCode: '+1',
    iso: 'KN',
    flag: 'assets/svg-flags/kn.svg',
    mask: '(869) 000-0000'
  },
  {
    label: 'Others',
    name: 'Saint Lucia',
    countryCode: '+1',
    iso: 'LC',
    flag: 'assets/svg-flags/lc.svg',
    mask: '(758) 000-0000'
  },
  {
    label: 'Others',
    name: 'Saint Martin',
    countryCode: '+590',
    iso: 'MF',
    flag: 'assets/svg-flags/mf.svg',
    mask: '(000) 000-000'
  },
  {
    label: 'Others',
    name: 'Saint Pierre and Miquelon',
    countryCode: '+508',
    iso: 'PM',
    flag: 'assets/svg-flags/pm.svg',
    mask: '00-0000'
  },
  {
    label: 'Others',
    name: 'Saint Vincent and the Grenadines',
    countryCode: '+1',
    iso: 'VC',
    flag: 'assets/svg-flags/vc.svg',
    mask: '(784) 000-0000'
  },
  {
    label: 'Others',
    name: 'Samoa',
    countryCode: '+685',
    iso: 'WS',
    flag: 'assets/svg-flags/ws.svg',
    mask: '00-0000'
  },
  {
    label: 'Others',
    name: 'San Marino',
    countryCode: '+378',
    iso: 'SM',
    flag: 'assets/svg-flags/sm.svg',
    mask: '0000-000000'
  },
  {
    label: 'Others',
    name: 'Sao Tome and Principe',
    countryCode: '+239',
    iso: 'ST',
    flag: 'assets/svg-flags/st.svg',
    mask: '00-00000'
  },
  {
    label: 'Others',
    name: 'Saudi Arabia',
    countryCode: '+966',
    iso: 'SA',
    flag: 'assets/svg-flags/sa.svg',
    mask: [
      '0-000-0000',
      '50-0000-0000'
    ]
  },
  {
    label: 'Others',
    name: 'Senegal',
    countryCode: '+221',
    iso: 'SN',
    flag: 'assets/svg-flags/sn.svg',
    mask: '00-000-0000'
  },
  {
    label: 'Others',
    name: 'Serbia',
    countryCode: '+381',
    iso: 'RS',
    flag: 'assets/svg-flags/rs.svg',
    mask: '00-000-0000'
  },
  {
    label: 'Others',
    name: 'Seychelles',
    countryCode: '+248',
    iso: 'SC',
    flag: 'assets/svg-flags/sc.svg',
    mask: '0-000-000'
  },
  {
    label: 'Others',
    name: 'Sierra Leone',
    countryCode: '+232',
    iso: 'SL',
    flag: 'assets/svg-flags/sl.svg',
    mask: '00-000000'
  },
  {
    label: 'Others',
    name: 'Singapore',
    countryCode: '+65',
    iso: 'SG',
    flag: 'assets/svg-flags/sg.svg',
    mask: '0000-0000'
  },
  {
    label: 'Others',
    name: 'Sint Maarten',
    countryCode: '+1',
    iso: 'SX',
    flag: 'assets/svg-flags/sx.svg',
    mask: '(721) 000-0000'
  },
  {
    label: 'Others',
    name: 'Slovakia',
    countryCode: '+421',
    iso: 'SK',
    flag: 'assets/svg-flags/sk.svg',
    mask: '(000) 000-000'
  },
  {
    label: 'Others',
    name: 'Slovenia',
    countryCode: '+386',
    iso: 'SI',
    flag: 'assets/svg-flags/si.svg',
    mask: '00-000-000'
  },
  {
    label: 'Others',
    name: 'Solomon Islands',
    countryCode: '+677',
    iso: 'SB',
    flag: 'assets/svg-flags/sb.svg',
    mask: [
      '00000',
      '000-0000'
    ]
  },
  {
    label: 'Others',
    name: 'Somalia',
    countryCode: '+252',
    iso: 'SO',
    flag: 'assets/svg-flags/so.svg',
    mask: [
      '0-000-000',
      '00-000-000'
    ]
  },
  {
    label: 'Others',
    name: 'South Africa',
    countryCode: '+27',
    iso: 'ZA',
    flag: 'assets/svg-flags/za.svg',
    mask: '00-000-0000'
  },
  {
    label: 'Others',
    name: 'South Georgia and the South Sandwich Islands',
    countryCode: '+500',
    iso: 'GS',
    flag: 'assets/svg-flags/gs.svg',
    mask: '00000'
  },
  {
    label: 'Others',
    name: 'South Sudan',
    countryCode: '+211',
    iso: 'SS',
    flag: 'assets/svg-flags/ss.svg',
    mask: '00-000-0000'
  },
  {
    label: 'Others',
    name: 'Spain',
    countryCode: '+34',
    iso: 'ES',
    flag: 'assets/svg-flags/es.svg',
    mask: '(000) 000-000'
  },
  {
    label: 'Others',
    name: 'Sri Lanka',
    countryCode: '+94',
    iso: 'LK',
    flag: 'assets/svg-flags/lk.svg',
    mask: '00-000-0000'
  },
  {
    label: 'Others',
    name: 'Sudan',
    countryCode: '+249',
    iso: 'SD',
    flag: 'assets/svg-flags/sd.svg',
    mask: '00-000-0000'
  },
  {
    label: 'Others',
    name: 'Suriname',
    countryCode: '+597',
    iso: 'SR',
    flag: 'assets/svg-flags/sr.svg',
    mask: [
      '000-000',
      '000-0000'
    ]
  },
  {
    label: 'Others',
    name: 'Svalbard and Jan Mayen',
    countryCode: '+47',
    iso: 'SJ',
    flag: 'assets/svg-flags/sj.svg',
    mask: '(000) 00-000'
  },
  {
    label: 'Others',
    name: 'Sweden',
    countryCode: '+46',
    iso: 'SE',
    flag: 'assets/svg-flags/se.svg',
    mask: '00-000-0000'
  },
  {
    label: 'Others',
    name: 'Switzerland',
    countryCode: '+41',
    iso: 'CH',
    flag: 'assets/svg-flags/ch.svg',
    mask: '00-000-0000'
  },
  {
    label: 'Others',
    name: 'Syrian Arab Republic',
    countryCode: '+963',
    iso: 'SY',
    flag: 'assets/svg-flags/sy.svg',
    mask: '00-0000-000'
  },
  {
    label: 'Others',
    name: 'Taiwan',
    countryCode: '+886',
    iso: 'TW',
    flag: 'assets/svg-flags/tw.svg',
    mask: [
      '0000-0000',
      '0-0000-0000'
    ]
  },
  {
    label: 'Others',
    name: 'Tajikistan',
    countryCode: '+992',
    iso: 'TJ',
    flag: 'assets/svg-flags/tj.svg',
    mask: '00-000-0000'
  },
  {
    label: 'Others',
    name: 'Tanzania, United Republic of Tanzania',
    countryCode: '+255',
    iso: 'TZ',
    flag: 'assets/svg-flags/tz.svg',
    mask: '00-000-0000'
  },
  {
    label: 'Others',
    name: 'Thailand',
    countryCode: '+66',
    iso: 'TH',
    flag: 'assets/svg-flags/th.svg',
    mask: [
      '00-000-000',
      '00-000-0000'
    ]
  },
  {
    label: 'Others',
    name: 'Timor-Leste',
    countryCode: '+670',
    iso: 'TL',
    flag: 'assets/svg-flags/tl.svg',
    mask: [
      '000-0000',
      '770-00000',
      '780-00000'
    ]
  },
  {
    label: 'Others',
    name: 'Togo',
    countryCode: '+228',
    iso: 'TG',
    flag: 'assets/svg-flags/tg.svg',
    mask: '00-000-000'
  },
  {
    label: 'Others',
    name: 'Tokelau',
    countryCode: '+690',
    iso: 'TK',
    flag: 'assets/svg-flags/tk.svg',
    mask: '0000'
  },
  {
    label: 'Others',
    name: 'Tonga',
    countryCode: '+676',
    iso: 'TO',
    flag: 'assets/svg-flags/to.svg',
    mask: '00000'
  },
  {
    label: 'Others',
    name: 'Trinidad and Tobago',
    countryCode: '+1',
    iso: 'TT',
    flag: 'assets/svg-flags/tt.svg',
    mask: '(868) 000-0000'
  },
  {
    label: 'Others',
    name: 'Tunisia',
    countryCode: '+216',
    iso: 'TN',
    flag: 'assets/svg-flags/tn.svg',
    mask: '00-000-000'
  },
  {
    label: 'Others',
    name: 'Turkey',
    countryCode: '+90',
    iso: 'TR',
    flag: 'assets/svg-flags/tr.svg',
    mask: '(000) 000-0000'
  },
  {
    label: 'Others',
    name: 'Turkmenistan',
    countryCode: '+993',
    iso: 'TM',
    flag: 'assets/svg-flags/tm.svg',
    mask: '0-000-0000'
  },
  {
    label: 'Others',
    name: 'Turks and Caicos Islands',
    countryCode: '+1',
    iso: 'TC',
    flag: 'assets/svg-flags/tc.svg',
    mask: '(249) 000-000'
  },
  {
    label: 'Others',
    name: 'Tuvalu',
    countryCode: '+688',
    iso: 'TV',
    flag: 'assets/svg-flags/tv.svg',
    mask: [
      '20000',
      '900000'
    ]
  },
  {
    label: 'Others',
    name: 'Uganda',
    countryCode: '+256',
    iso: 'UG',
    flag: 'assets/svg-flags/ug.svg',
    mask: '(000) 000-000'
  },
  {
    label: 'Others',
    name: 'Ukraine',
    countryCode: '+380',
    iso: 'UA',
    flag: 'assets/svg-flags/ua.svg',
    mask: '(00) 000-00-00'
  },
  {
    label: 'Others',
    name: 'United Arab Emirates',
    countryCode: '+971',
    iso: 'AE',
    flag: 'assets/svg-flags/ae.svg',
    mask: [
      '0-000-0000',
      '50-000-0000'
    ]
  },
  {
    label: 'Others',
    name: 'United Kingdom',
    countryCode: '+44',
    iso: 'GB',
    flag: 'assets/svg-flags/gb.svg',
    mask: '00-0000-0000'
  },
  {
    label: 'Others',
    name: 'Uruguay',
    countryCode: '+598',
    iso: 'UY',
    flag: 'assets/svg-flags/uy.svg',
    mask: '0-000-00-00'
  },
  {
    label: 'Others',
    name: 'Uzbekistan',
    countryCode: '+998',
    iso: 'UZ',
    flag: 'assets/svg-flags/uz.svg',
    mask: '00-000-0000'
  },
  {
    label: 'Others',
    name: 'Vanuatu',
    countryCode: '+678',
    iso: 'VU',
    flag: 'assets/svg-flags/vu.svg',
    mask: [
      '00000',
      '00-00000'
    ]
  },
  {
    label: 'Others',
    name: 'Venezuela, Bolivarian Republic of Venezuela',
    countryCode: '+58',
    iso: 'VE',
    flag: 'assets/svg-flags/ve.svg',
    mask: '(000) 000-0000'
  },
  {
    label: 'Others',
    name: 'Vietnam',
    countryCode: '+84',
    iso: 'VN',
    flag: 'assets/svg-flags/vn.svg',
    mask: [
      '00-0000-000',
      '(000) 0000-000'
    ]
  },
  {
    label: 'Others',
    name: 'Virgin Islands, British',
    countryCode: '+1',
    iso: 'VG',
    flag: 'assets/svg-flags/vg.svg',
    mask: '(284) 000-0000'
  },
  {
    label: 'Others',
    name: 'Virgin Islands, U.S.',
    countryCode: '+1',
    iso: 'VI',
    flag: 'assets/svg-flags/vi.svg',
    mask: '(340) 000-0000'
  },
  {
    label: 'Others',
    name: 'Wallis and Futuna',
    countryCode: '+681',
    iso: 'WF',
    flag: 'assets/svg-flags/wf.svg',
    mask: '00-0000'
  },
  {
    label: 'Others',
    name: 'Yemen',
    countryCode: '+967',
    iso: 'YE',
    flag: 'assets/svg-flags/ye.svg',
    mask: [
      '0-000-000',
      '00-000-000',
      '000-000-000'
    ]
  },
  {
    label: 'Others',
    name: 'Zambia',
    countryCode: '+260',
    iso: 'ZM',
    flag: 'assets/svg-flags/zm.svg',
    mask: '00-000-0000'
  },
  {
    label: 'Others',
    name: 'Zimbabwe',
    countryCode: '+263',
    iso: 'ZW',
    flag: 'assets/svg-flags/zw.svg',
    mask: '0-000000'
  }
];
